import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

function BusinessAi({ getData }) {
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    getData("AI", "인공지능을 통한 3D 객체 분류 및", "인식 기술을 제공합니다.");
    window.addEventListener("scroll", updateScroll);
  }, [getData]);
  
  // 스크롤 pc
  const updateScroll = () => {
    setScrollPosition(window.scrollY || document.documentElement.scrollTop);
  };

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
    {
      pc ? 
      (
        <div>
        <div className="inner">
          <h2 className="basic-title">AI 보유 기술</h2>
          <div className="basic-subtitle">
            <p>
              AI를 활용한 응용 서비스로써 포인트 클라우드로 3D 객체를 인식,
              분류를 통하여
            </p>
            <p>
              공장형 건물에서의 구조물들의 객체 정보, 건물 내부의 가구 등의 객체
              정보를 제공합니다.
            </p>
          </div>
          <div>
            <ul className="technology-list">
              <li className="technology-item">
                <span className="technology-img ai-img1"></span>
                <h2 className="technology-name">포인트 클라우드 객체 분류</h2>
              </li>
              <li className="technology-item">
                <span className="technology-img ai-img2"></span>
                <h2 className="technology-name">
                  포인트 클라우드 객체 인식(분할)
                </h2>
              </li>
              <li className="technology-item">
                <span className="technology-img ai-img3"></span>
                <h2 className="technology-name">
                  BIM 데이터를 학습용 데이터 생성
                </h2>
              </li>
              <li className="technology-item">
                <span className="technology-img ai-img4"></span>
                <h2 className="technology-name">
                  <span className="basic-block">
                    BIM 구조 데이터에서 PointCloud
                  </span>
                  <span className="basic-block">
                    데이터로 변환하는 서비스 제공
                  </span>
                </h2>
              </li>
              <li className="technology-item">
                <span className="technology-img ai-img5"></span>
                <h2 className="technology-name">
                  <span className="basic-block">
                    딥러닝을 통한 PointCloud 객체
                  </span>
                  <span className="basic-block">분류 솔루션 보유</span>
                </h2>
              </li>
              <li className="technology-item">
                <span className="technology-img ai-img6"></span>
                <h2 className="technology-name">
                  <span className="basic-block">
                    딥러닝을 통한 PointCloud 객체
                  </span>
                  <span className="basic-block">인식/분할 솔루션 보유</span>
                </h2>
              </li>
            </ul>
          </div>
        </div>

        <div className={ scrollPosition > 1299 ? "basic-banner ai-banner on" : "basic-banner ai-banner"}> 
          <h2 className="basic-banner-title">
            <p className="txt">인공지능을 통한 3D 객체</p>
            <p className="txt">분류 및 인식 기술 제공 서비스</p>
          </h2>
        </div>

        <div className="inner">
          <ul className="business-list">
            <li className="business-item">
              <h2 className="business-title">기업부설연구소 AI 기술 개발</h2>
              <div className="business-cont">
                <div className="business-txt">
                  <h3 className="txt">
                    건물의 구조를 나타내는 BIM형식의 정보로 mesh 표면에 여러
                    가지 분포의 포인트 클라우드를 생성함으로써 딥러닝에 사용될
                    학습 데이터를 필요한 만큼 대량 생성이 가능합니다.
                  </h3>
                  <h3 className="txt">
                    필요한 만큼의 학습 데이터로 딥러닝을 이용하여
                    객체를 분류하는 솔루션을 개발합니다.
                  </h3>
                </div>
                <ul className="basic-cont-list">
                  <li className="basic-cont-item">
                    BIM(Building Information Modeling)을 PCD(포인트 클라우드
                    데이터)로의 변환 기술 개발
                  </li>
                  <li className="basic-cont-item">
                    딥러닝을 이용한 3차원 포인트 클라우드의 객체 분류 및 추출
                  </li>
                  <li className="basic-cont-item">
                    건물 포인트 클라우드를 통한 평면도 추출
                  </li>
                </ul>
                <div>
                  <ul className="business-img-list">
                    <li className="business-img-item">
                      <span className="business-img ai-img1"></span>
                    </li>
                    <li className="business-img-item">
                      <span className="business-img ai-img2"></span>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      ) :
      (
        <div>
        <div className="inner">
          <h2 className="basic-title">
              <span className="txt">AI</span>
              <span className="txt">보유 기술</span></h2>
          <div className="basic-subtitle">
            <p>
              AI를 활용한 응용 서비스로써 포인트 클라우드로 3D 객체를 인식,
              분류를 통하여 공장형 건물에서의 구조물들의 객체 정보, 건물 내부의 가구 등의 객체
              정보를 제공합니다.
            </p>
          </div>
          <div>
            <ul className="technology-list">
              <li className="technology-item">
                <span className="technology-img ai-img1"></span>
                <h2 className="technology-name"><span className="basic-block">
                포인트 클라우드
                  </span>
                  <span className="basic-block">
                  객체 분류
                  </span>   </h2>
              </li>
              <li className="technology-item">
                <span className="technology-img ai-img2"></span>
                <h2 className="technology-name"><span className="basic-block">
                포인트 클라우드
                  </span>
                  <span className="basic-block">
                  객체 인식(분할)
                  </span>  
                   
                </h2>
              </li>
              <li className="technology-item">
                <span className="technology-img ai-img3"></span>
                <h2 className="technology-name"><span className="basic-block">
                BIM 데이터를
                  </span>
                  <span className="basic-block">
                  학습용 데이터 생성
                  </span>  
                   
                </h2>
              </li>
              <li className="technology-item">
                <span className="technology-img ai-img4"></span>
                <h2 className="technology-name">
                  <span className="basic-block">
                    BIM 구조 데이터에
                  </span>
                  <span className="basic-block">
                  서 PointCloud  
                  </span>
                  <span className="basic-block">
                  데이터로 변환하는
                  </span>
                  <span className="basic-block">
                    서비스 제공
                  </span>
                </h2>
              </li>
              <li className="technology-item">
                <span className="technology-img ai-img5"></span>
                <h2 className="technology-name">
                  <span className="basic-block">
                    딥러닝을 통한 
                  </span>
                  <span className="basic-block">PointCloud 객체</span>
                  <span className="basic-block">분류 솔루션 보유</span>
                </h2>
              </li>
              <li className="technology-item">
                <span className="technology-img ai-img6"></span>
                <h2 className="technology-name">
                  <span className="basic-block">
                    딥러닝을 통한
                  </span>
                  <span className="basic-block">PointCloud 객체</span>
                  <span className="basic-block">인식/분할 솔루션</span>
                  <span className="basic-block">보유</span>
                </h2>
              </li>
            </ul>
          </div>
        </div>

        <div className="basic-banner ai-banner">
          <h2 className="basic-banner-title">
            <p className="txt">인공지능을 통한</p>
            <p className="txt">3D 객체 분류 및 인식</p>
            <p className="txt">기술 제공 서비스</p>
          </h2>
        </div>

        <div className="inner">
          <ul className="business-list">
            <li className="business-item">
              <h2 className="business-title">기업부설연구소 AI 기술 개발</h2>
              <div className="business-cont">
                <div className="business-txt">
                  <h3 className="txt">
                    건물의 구조를 나타내는 BIM형식의 정보로 mesh 표면에 여러
                    가지 분포의 포인트 클라우드를 생성함으로써 딥러닝에 사용될
                    학습 데이터를 필요한 만큼 대량 생성이
                    가능합니다. 필요한 만큼의 학습 데이터로 딥러닝을 이용하여
                    객체를 분류하는 솔루션을 개발합니다.
                  </h3>
                </div>
                <div>
                  <ul className="business-img-list">
                    <li className="business-img-item">
                      <span className="business-img ai-img1"></span>
                    </li>
                    <li className="business-img-item">
                      <span className="business-img ai-img2"></span>
                    </li>
                  </ul>
                </div>
                <ul className="basic-cont-list">
                  <li className="basic-cont-item">
                    BIM(Building Information Modeling)을 PCD(포인트 클라우드
                    데이터)로의 변환 기술 개발
                  </li>
                  <li className="basic-cont-item">
                    딥러닝을 이용한 3차원 포인트 클라우드의 객체 분류 및 추출
                  </li>
                  <li className="basic-cont-item">
                    건물 포인트 클라우드를 통한 평면도 추출
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
      )
    }
      
    </>
  );
}

export default BusinessAi;
